const mode = "DEV";
// const mode = "PROD";

export const BASE_URL =
  mode === "PROD"
    ? " https://api.pinalsand.com"
    : "https://api.pinalsand.vytech.co";

export const BASE_URL_UPLOAD =
  mode === "PROD"
    ? " https://api.pinalsand.com/uploads"
    : "https://api.pinalsand.vytech.co/uploads";
